import { createEffect, createStore } from 'effector';
import { WorksListResponse, Data } from '../../interfaces';

const fxGetList = createEffect<void, WorksListResponse, Error>();

const $data = createStore<Data[]>([]);
const $isLoading = createStore<boolean>(false);

export { fxGetList, $data, $isLoading };
